import client from "~/apis/client"

export function fetchMessageTemplates() {
  return client.get("/message_templates")
}

export function updateMessageTemplate(id, body) {
  return client.patch(`/message_templates/${id}`, { body })
}
